"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _noop = _interopRequireDefault(require("lodash/fp/noop"));
var FormStateWatcher = function FormStateWatcher(_ref) {
  var values = _ref.values,
    errors = _ref.errors,
    touched = _ref.touched,
    isSubmitting = _ref.isSubmitting,
    isValidating = _ref.isValidating,
    isValid = _ref.isValid,
    dirty = _ref.dirty,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _noop["default"] : _ref$onChange;
  var firstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (!firstUpdate.current) {
      onChange({
        values: values,
        errors: errors,
        touched: touched,
        isSubmitting: isSubmitting,
        isValidating: isValidating,
        isValid: isValid,
        dirty: dirty
      });
    }
    firstUpdate.current = false;
  }, [values, errors, touched, isSubmitting, isValidating, isValid, onChange, dirty]);
  return null;
};
var _default = exports["default"] = FormStateWatcher;